import { Chip } from "@mui/material";
import React from "react";
import AddButton from "./AddButton";
import AddResourceDialog from "./AddResourceDialog";
import mut from "../hooks/mut";
import QRCode from "react-qr-code";
import Lang from "./Lang";
import IconButtonHT from "./IconButtonHT";


export default function ResourceList({ value, setValue, label, type = "chip", canDelete = false, field, url, defaultName, generated = false, required }) {
  


    const [open, setOpen] = React.useState(false)

  


  
    const addResource = async (newResource) => { 
        if (url) {
            const newResources = [...value[field], newResource];
            let result = await mut("post", url, { [field]: newResources })
            setValue(prev => {   
                return {...prev, [field]: result[field]}
            })
        }
        else{
        setValue(prev => {
            const newResources = [...prev[field], newResource]
            return {...prev, [field]: newResources}
        })
    }
    }

    const deleteResource = async (_id) => { 
        if (url) {
          const newResources = [...value[field].filter((v) => v._id !== _id)];
          let result = await mut("post", url, { [field]: newResources });
          setValue((prev) => {
            return { ...prev, [field]: result[field] };
          });
        } else {
          setValue((prev) => {
            const newResources = [...value[field].filter((v) => v._id !== _id)];
            return { ...prev, [field]: newResources };
          });
        }
    }
  
  const handeNotRequired = async () => {
    console.log(field)
    const fieldName = field + "NotRequired"
    let v = value[fieldName] || false
    let result = await mut("post", url, { [fieldName]: !v });
     setValue((prev) => {
       return {
         ...prev,
         [fieldName]: result[fieldName],
       };
     });
  }

  const notReq = field+"NotRequired"
  

  if (!setValue) return (
    <div style={{ padding: 5, textAlign: "center" }}>
      {label}
      <div style={{ display: "flex", gap: 10, flexDirection: "column" }}>
        {value[field].map((v) => 
      
          <ShowLink
           resource={v}
           type={type}
          />
        
         
        )}
      </div>
    </div>
  );
  
    return (
      <div
        style={{
          border: "1px solid #ccc",
          paddingLeft: 5,
          paddingRight: 5,
          paddingBottom: 10,
          borderRadius: 10,
          minWidth: 300,
          color: value[notReq] ? "#ccc": "black",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            paddingTop: 0,
            justifyContent: "space-between",
          }}
        >
          <div>{label}</div>
          <div>
            <AddButton
              action={() => setOpen(true)}
              disabled={value[notReq]}
            />
            {required &&
              (value[notReq] ? (
                <IconButtonHT
                  icon="tick"
                  toolTip={`${label} required`}
                  color="green"
                  action={handeNotRequired}
                />
              ) : (
                <IconButtonHT
                  icon="x"
                  toolTip={`No ${label} required`}
                  color="red"
                  action={handeNotRequired}
                />
              ))}
          </div>
        </div>
        {!value[notReq] && (
          <div style={{ display: "flex", gap: 10, flexDirection: "column" }}>
            {value[field].map((v) => (
              <ShowLink
                resource={v}
                type={type}
                onDelete={() => deleteResource(v._id)}
              />
            ))}
          </div>
        )}

        {open && (
          <AddResourceDialog
            open={open}
            setOpen={setOpen}
            title="Add Resource"
            defaultName={defaultName}
            setValue={(newResource) => {
              addResource(newResource);
              setOpen(false);
            }}
          />
        )}
      </div>
    );
}

function ShowLink({ label, type, onDelete, resource }) {
  
  const link = resource.fileId
    ? "https://docs.google.com/document/d/"+resource.fileId
    : resource.link;
  if (type === "link") return <a href={link} target="_blank" rel="noreferrer">{resource.name}</a>
  if (type === "qr") return (

      <div
        style={{
          display: "flex",
          gap: 20,
          border: "1px solid #ccc",
          padding: 10,
          borderRadius: 10,
        }}
      >
        <QRCode
          value={link}
          size={128}
        />
        <div>
          <div style={{ fontWeight: "bold" }}>{label}</div>
          <div>
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className="neat"
            >
              {link}
            </a>
          </div>
        </div>
      </div>

  );

  return (
    <Chip
      label={<Label resource={resource} />}
      onClick={() => window.open(link)}
      clickable
      onDelete={onDelete}
      sx={{height:40}}
    />
  );
  
}

function Label({ resource }) {
 
   

  if (!resource.fileId) return <div>{resource.name}</div>
  
  let type = "vietnameseTeacher"
  if (resource.type === "GVNNLessonPlan") type = "foreignTeacher"
  if (resource.type==="TALessonPlan") type= "teachingAssistant"

  return (
    <div>
      <div>{resource.name}</div>
      <div className="text-xs"><Lang w={type} /></div>
    </div>
  );
}